import { render, staticRenderFns } from "./calcVesselsDotsRow.vue?vue&type=template&id=4c7b2667&scoped=true"
import script from "./calcVesselsDotsRow.vue?vue&type=script&lang=js"
export * from "./calcVesselsDotsRow.vue?vue&type=script&lang=js"
import style0 from "./calcVesselsDotsRow.vue?vue&type=style&index=0&id=4c7b2667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7b2667",
  null
  
)

export default component.exports